<template lang="pug">
svg(
    :width="size"
    :height="size"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
)
    path(
        :class="{ error: error, success: success }"
        d="M6.11959e-07 9L12.17 9L6.58 14.59L8 16L16 8L8 -6.99382e-07L6.59 1.41L12.17 7L7.86805e-07 7L6.11959e-07 9Z"
        class="svg"
    )
</template>

<script setup>
import { computed } from 'vue'

const props = defineProps({
    size: {
        type: [String, Number],
        default: 14,
    },
    error: Boolean,
    success: Boolean,
})

const size = computed(() => parseInt(`${props.size}`, 10))
</script>
